import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { Permissions } from '@askporter/auth-provider';
import { UserExportCreate, UserExportCreateFieldsEnum } from '@askporter/client-grieg-lyric';
import { exportUsersCheckboxFieldsPermissionMapping } from '../../../utils/exportCheckboxFieldPermissionMapping';
import { ExportFieldCheckbox } from '../../ExportFieldCheckbox';

interface ExportUsersFieldsProps {
  /**
   * The translation function
   */
  t: (key: string, options?: Record<string, string | number>) => string;
  /**
   * The form control
   */
  control: Control<UserExportCreate>;
  // TODO: Weird error(Passing UserExportModalFormControlType from ../../../types causes a resolver error)
}

/**
 * Renders the checkboxes for the users export modal based on the user's role
 */
export const ExportUsersFields: React.FC<ExportUsersFieldsProps> = ({ t, control }) => {
  const nonEssentialFields = Object.values(UserExportCreateFieldsEnum);

  return (
    <>
      <Permissions requiredRoles={exportUsersCheckboxFieldsPermissionMapping.USER_ESSENTIALS}>
        <ExportFieldCheckbox
          fieldId="USER_ESSENTIALS"
          disabled={true}
          label={t('users:export_modal:user_essentials:checkbox:label')}
          subLabel={t('users:export_modal:user_essentials:checkbox:subLabel')}
          isChecked={true}
        />
      </Permissions>

      {nonEssentialFields.map((fieldId, index) => (
        <Permissions key={index} requiredRoles={exportUsersCheckboxFieldsPermissionMapping[fieldId]}>
          <Controller
            name="fields"
            control={control}
            defaultValue={[]}
            render={({ field }) => (
              <ExportFieldCheckbox
                fieldId={fieldId}
                label={t(`users:export_modal:${fieldId.toLowerCase()}:checkbox:label`)}
                subLabel={t(`users:export_modal:${fieldId.toLowerCase()}:checkbox:subLabel`)}
                isChecked={field.value.includes(fieldId)}
                onChange={(checked) =>
                  field.onChange(checked ? [...field.value, fieldId] : field.value.filter((value) => value !== fieldId))
                }
                disabled={field.disabled}
              />
            )}
          />
        </Permissions>
      ))}
    </>
  );
};
